import React from 'react';
export const StatsBar = () => {
  return <div className="bg-navy-800 border-y border-navy-700 py-6" data-id="element-272">
      <div className="max-w-6xl mx-auto px-4" data-id="element-273">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center divide-x divide-navy-700" data-id="element-274">
          <div data-id="element-275">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-276">
              +1.200
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-277">
              familias
            </div>
          </div>
          <div data-id="element-278">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-279">
              5
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-280">
              Tomos
            </div>
          </div>
          <div data-id="element-281">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-282">
              5
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-283">
              Bonos
            </div>
          </div>
          <div data-id="element-284">
            <div className="text-3xl font-serif font-bold text-gold-400 mb-1" data-id="element-285">
              4.9/5
            </div>
            <div className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-286">
              ⭐⭐⭐⭐⭐
            </div>
          </div>
        </div>
      </div>
    </div>;
};